<template>
  <div class="tongji-container">
    <!-- 筛选栏 -->
    <el-card class="filter-card">
      <el-form v-model="form" :inline="true" class="form">
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label=" " class="button-item">
          <el-button type="primary" style="width: 100%" @click="handleQuery">
            查询统计
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 核心数据卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">总检测</div>
          <div class="stat-value text-primary">{{ data.totalCount }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">日均检测</div>
          <div class="stat-value text-success">{{ (data.totalCount/data.countTotalDays).toFixed(2) }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">平和质占比</div>
          <div class="stat-value text-info">{{ data.phy1Ratio }}%</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-label">偏颇体质占比</div>
          <div class="stat-value text-warning">{{ 100 - data.phy1Ratio }}%</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 每日检测人数趋势图 -->
    <el-card class="chart-card">
      <div slot="header">
        <span>每日检测人数趋势</span>
      </div>
      <div ref="dailyChart" class="chart-container" style="height: 400px;" />
    </el-card>

    <!-- 每日体质检测明细表格 -->
    <el-card class="table-card">
      <div slot="header">
        <span>每日体质检测明细</span>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%" show-summary :summary-method="getSummaries">
        <el-table-column prop="date" label="日期" align="center" />
        <el-table-column prop="robotName" label="设备编号" align="center" />
        <el-table-column prop="storeName" label="门店名称" align="center" />
        <el-table-column prop="totalCount" label="检测总人数" align="center" />
        <el-table-column v-for="item in constitutionTypes" :key="item.key" :prop="item.key" :label="item.label" align="center">
          <template slot-scope="scope">
            <div class="clickable-number" @click="handleConstitutionClick(scope.row, item.key)">{{ scope.row[item.key] }}</div>
            <div class="ratio-text">{{ scope.row[item.key + 'Percent'] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 体质分布饼图 -->
    <el-card class="chart-card">
      <div slot="header">
        <span>体质类型分布占比</span>
      </div>
      <div ref="pieChart" class="chart-container" style="height: 400px;" />
    </el-card>
    <!-- 体质明细弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="92%"
      top="4vh"
      :close-on-click-modal="false"
      custom-class="phy-dialog"
      :z-index="2000"
    >
      <PhyDiagRecord2
        v-if="dialogVisible"
        :dialog-query="dialogQuery"
        @close="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { postData } from '@/api/user/authApi'
import PhyDiagRecord2 from '@/components/PhyDiagRecord2.vue'
import * as echarts from 'echarts'

export default {
  name: 'Tongji1',
  components: { PhyDiagRecord2 },
  data() {
    // 获取当月起止日期
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')

    // 结束日期：今天
    const endDate = `${year}-${month}-${day}`

    // 开始日期：两个月前的1号（n-2月），自动处理跨年
    const start = new Date(now.getFullYear(), now.getMonth() - 2, 1)
    const startYear = start.getFullYear()
    const startMonth = String(start.getMonth() + 1).padStart(2, '0')
    const startDate = `${startYear}-${startMonth}-01`
    return {
      form: {
        startDate: startDate,
        endDate: endDate
      },
      data: {
        totalCount: 0,
        phy1Ratio: 0,
        phy1Count: 0,
        countTotalDays: 0
      },
      dailyChart: null,
      pieChart: null,
      constitutionTypes: [
        { key: 'phz', label: '平和质' },
        { key: 'qxz', label: '气虚质' },
        { key: 'yax', label: '阳虚质' },
        { key: 'yix', label: '阴虚质' },
        { key: 'tsz', label: '痰湿质' },
        { key: 'srz', label: '湿热质' },
        { key: 'xyz', label: '血瘀质' },
        { key: 'qyz', label: '气郁质' },
        { key: 'tbz', label: '特禀质' }
      ],
      tableData: [],
      // 存储每日检测图表数据
      dailyChartData: {
        dates: [],
        values: []
      },
      // 存储饼图数据
      pieChartData: [],
      // 弹窗相关
      dialogVisible: false,
      dialogQuery: null
    }
  },
  mounted() {
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
    // 页面加载时自动获取数据
    this.gettableData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.dailyChart) this.dailyChart.dispose()
    if (this.pieChart) this.pieChart.dispose()
  },
  methods: {
    initCharts() {
      this.initDailyChart()
      this.initPieChart()
    },

    // 点击体质数字弹窗打开明细
    handleConstitutionClick(row, constitutionKey) {
      const constitutionCode = constitutionKey.toUpperCase()
      const query = {
        mainPhyCode: constitutionCode,
        minDiagTime: row.date + ' 00:00:00',
        maxDiagTime: row.date + ' 23:59:59'
      }
      if (row.storeCode) {
        query.storeCode = row.storeCode
      }
      if (row.storeName) {
        query.storeName = row.storeName
      }
      this.dialogQuery = query
      this.dialogVisible = true
    },

    gettableData() {
      const storeId = this.$store.getters['user/getStoreId']
      const p = {
        startTime: this.form.startDate + ' 00:00:00',
        endTime: this.form.endDate + ' 23:59:59',
        storeId: storeId
      }
      postData('daocui-board/board/diagnosis/phydiagrecordBoard/find/dataStatistics', p).then(res => {
        console.log(res)
        this.data.countTotalDays = res.data.countTotalDays
        this.data.phy1Count = res.data.phy1Count
        this.data.phy1Ratio = res.data.phy1Ratio
        this.data.totalCount = res.data.totalCount
        this.tableData = this.processTableData(res.data.PhyDiagRecordList)

        // 处理 dailyCountMap 数据
        if (res.data.dailyCountMap) {
          this.processDailyChartData(res.data.dailyCountMap)
        }

        // 处理体质分布数据（饼图）
        this.processPieChartData(res.data)
      })
    },
    // 处理每日检测图表数据
    processDailyChartData(dailyCountMap) {
      // 将对象转换为数组并按日期排序
      const entries = Object.entries(dailyCountMap)

      // 按日期升序排序
      entries.sort((a, b) => new Date(a[0]) - new Date(b[0]))

      // 分离日期和数值
      this.dailyChartData.dates = entries.map(item => item[0])
      this.dailyChartData.values = entries.map(item => item[1])

      // 更新图表
      this.updateDailyChart()
    },
    // 处理饼图数据
    processPieChartData(data) {
      // 兼容：后端当前返回 YAZ，未来改为 YAX，若 YAX 不存在而 YAZ 存在则复制
      if (data.YAX === undefined && data.YAZ !== undefined) {
        data.YAX = data.YAZ
      }

      // 体质类型映射配置（后端字段名、中文名、颜色）
      const constitutionMap = [
        { key: 'PHZ', label: '平和质', color: '#4BC0C0' },
        { key: 'QXZ', label: '气虚质', color: '#FF6384' },
        { key: 'YAX', label: '阳虚质', color: '#FF9F40' },
        { key: 'YIX', label: '阴虚质', color: '#FFCD56' },
        { key: 'TSZ', label: '痰湿质', color: '#36A2EB' },
        { key: 'SRZ', label: '湿热质', color: '#9966FF' },
        { key: 'XYZ', label: '血瘀质', color: '#C9CBCF' },
        { key: 'QYZ', label: '气郁质', color: '#21CC21' },
        { key: 'TBZ', label: '特禀质', color: '#F97316' }
      ]

      // 构建饼图数据数组
      const pieData = constitutionMap.map(item => ({
        value: data[item.key] || 0,
        name: item.label,
        itemStyle: { color: item.color }
      }))

      this.pieChartData = pieData

      // 更新饼图
      this.updatePieChart()
    },
    // 处理表格数据
    processTableData(data) {
      return data.map(item => {
        // 兼容：后端当前返回 yaz，未来改为 yax，若 yax 不存在而 yaz 存在则复制
        if (item.yax === undefined && item.yaz !== undefined) {
          item.yax = item.yaz
        }

        const total = item.totalCount || 1
        const result = { ...item }

        // 为每个体质字段计算百分比
        Object.keys(item).forEach(key => {
          if (/^[a-z]{3}$/.test(key) && key !== 'date' && key !== 'robotName' && key !== 'totalCount') {
            result[`${key}Percent`] = total > 0
              ? ((item[key] / total) * 100).toFixed(2) + '%'
              : '0.00%'
          }
        })

        return result
      })
    },
    initDailyChart() {
      this.dailyChart = echarts.init(this.$refs.dailyChart)
      // 初始空图表，等待数据加载后更新
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: { color: '#909399' }
        },
        xAxis: { type: 'category', data: [] },
        yAxis: { type: 'value' },
        series: []
      }
      this.dailyChart.setOption(option)
    },
    updateDailyChart() {
      const option = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>检测人数: {c} 人'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.dailyChartData.dates,
          name: '日期',
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: '检测人数',
          minInterval: 1
        },
        series: [{
          name: '检测人数',
          type: 'bar',
          data: this.dailyChartData.values,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' }
            ])
          },
          barWidth: '60%'
        }]
      }
      this.dailyChart.setOption(option, true)
    },
    initPieChart() {
      this.pieChart = echarts.init(this.$refs.pieChart)
      const option = {
        title: {
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: { color: '#909399' }
        },
        series: []
      }
      this.pieChart.setOption(option)
    },
    updatePieChart() {
      const option = {
        title: { show: false },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: '10%',
          top: 'center'
        },
        series: [{
          type: 'pie',
          radius: '60%',
          center: ['40%', '50%'],
          data: this.pieChartData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: true,
            formatter: '{b}: {c}人'
          }
        }]
      }
      this.pieChart.setOption(option, true)
    },
    handleQuery() {
      // 重新查询数据
      this.gettableData()
    },
    handleResize() {
      if (this.dailyChart) this.dailyChart.resize()
      if (this.pieChart) this.pieChart.resize()
    },
    // 表格汇总方法
    getSummaries(param) {
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1 || index === 2) {
          sums[index] = ''
          return
        }

        const values = data.map(item => Number(item[column.property]))
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + value
          }
          return prev
        }, 0)

        // 检测总人数列
        if (column.property === 'totalCount') {
          sums[index] = sum
          return
        }

        // 体质类型列，计算数量和百分比
        const constitutionKeys = this.constitutionTypes.map(t => t.key)
        if (constitutionKeys.includes(column.property)) {
          const total = sums[3] || 0 // 检测总人数在索引3（因为多了storeName列）
          const percent = total > 0 ? ((sum / total) * 100).toFixed(2) + '%' : '0.00%'
          sums[index] = '总数：' + sum + '\n' + '比例：' + percent
          return
        }

        sums[index] = ''
      })

      return sums
    }
  }
}
</script>

<style scoped>
.tongji-container {
  padding: 20px;
  background-color: #f5f7fa;
  height: calc(100vh - 50px);
  overflow: auto;
}
.form {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-title {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
  font-weight: 600;
}
.filter-card {
  margin-bottom: 20px;
}
.button-item {
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
}
.stats-row {
  margin-bottom: 20px;
}
.stat-card {
  text-align: center;
  padding: 10px;
}
.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
}
.text-primary { color: #409EFF; }
.text-success { color: #67C23A; }
.text-info { color: #909399; }
.text-warning { color: #E6A23C; }
.chart-card {
  margin-bottom: 20px;
}
.table-card {
  margin-bottom: 20px;
}
.chart-container {
  width: 100%;
}
.ratio-text {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 可点击数字样式 */
.clickable-number {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
}
.clickable-number:hover {
  color: #66b1ff;
}

/* 汇总行样式 */
>>> .el-table__footer-wrapper .el-table__footer td {
  font-weight: bold;
  background-color: #f5f7fa;
  white-space: pre-line;
  line-height: 1.5;
}

/* 弹窗样式 */
.phy-dialog {
  display: flex;
  flex-direction: column;
}
.phy-dialog .el-dialog__body {
  padding: 0;
  height: calc(92vh - 120px);
  overflow: hidden;
}
.phy-dialog .el-dialog__header {
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
}
.phy-dialog .el-dialog__headerbtn {
  top: 15px;
}
</style>
